import KetQuaThiPage from "./KetQuaThiPage";
export default KetQuaThiPage;